import React from 'react';
import { st, classes } from './SkeletonRectangle.st.css';
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './constants';
import { DEFAULT_SKIN } from '../SkeletonGroup/SkeletonGroup.constants';
import Box from '../Box';
import { SkeletonGroupContext } from '../SkeletonGroup';
import { SkeletonRectangleProps } from './SkeletonRectangle.types';

function SkeletonRectangle(props: SkeletonRectangleProps) {
  const {
    dataHook,
    className,
    height = DEFAULT_HEIGHT,
    width = DEFAULT_WIDTH,
    margin,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
  } = props;

  return (
    <SkeletonGroupContext.Consumer>
      {context => {
        const skin = (context && context.skin) || DEFAULT_SKIN;
        return (
          <div
            data-hook={dataHook}
            className={className}
            data-height={height}
            data-width={width}
            data-skin={skin}
          >
            <Box
              height={height}
              width={width}
              margin={margin}
              marginLeft={marginLeft}
              marginRight={marginRight}
              marginTop={marginTop}
              marginBottom={marginBottom}
              className={st(classes.root, { skin })}
            />
          </div>
        );
      }}
    </SkeletonGroupContext.Consumer>
  );
}

SkeletonRectangle.displayName = 'SkeletonRectangle';

export default SkeletonRectangle;
